import React, { useEffect } from "react";
import MainLayout from "../../Layout/mainLayout";
import { useState } from "react";
import "./listConfig.css";
import { useSelector } from "react-redux";
import axios from "axios";
import toast from "react-hot-toast";

const AddCountryConfig = () => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const [settingData, setSettingData] = useState("");

  const [countryConfig, setCountryConfig] = useState({
    setting_id: "",
    name: "",
    tax: "",
    currency: "",
    booking_amount_percent: "",
  });

  const handleAddChange = (event) => {
    const { name, value } = event.target;
    setCountryConfig((prevData) => ({ ...prevData, [name]: value }));
  };

  const { countryList } = useSelector((state) => state.country);

  useEffect(() => {
    const getConfigData = async () => {
      try {
        const responseData = await axios.get(`${BASE_URL}/setting/view`, {
          headers: {
            "Content-Type": "application/json",
          },
        });
        if (responseData.data) {
          setSettingData(responseData.data);
        }
      } catch (error) {
        console.error("Error in try catch block");
      }
    };
    getConfigData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (countryConfig.name) {
      setCountryConfig((prevData) => {
        const foundCurrency =
          Array.isArray(countryList?.data) &&
          countryList.data.find(
            (country) => country.country_code === countryConfig.name
          );

        return {
          ...prevData,
          setting_id: settingData?.data ? settingData.data._id : "0",
          currency: foundCurrency ? foundCurrency.country_currency : "", // Handle undefined case
        };
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [settingData?.data?.countryList, countryList.data, countryConfig.name]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (countryConfig) {
      try {
        await axios.post(`${BASE_URL}/setting/update`, countryConfig, {
          headers: {
            "Content-Type": "application/json",
          },
        });
        toast.success("Added Successfully!!");
      } catch (error) {
        console.error(error?.data?.response?.message);
      }
    }
  };

  return (
    <MainLayout>
      <div
        className="config_container_add"
        style={{
          gridColumn: "2/7",
          display: "grid",
          gridTemplateColumns: "repeat(2,1fr)",
        }}
      >
        <div>
          <span>Select Country</span>
          <select
            className="input-class"
            name="name"
            value={countryConfig.name}
            id=""
            onChange={handleAddChange}
          >
            <option selected hidden>
              Select an option
            </option>
            {Array.isArray(countryList?.data) &&
              countryList.data.map((country) => (
                <option key={country._id} value={country.country_code}>
                  {country.country_name}
                </option>
              ))}
          </select>
        </div>
        <div>
          <span>Enter Tax Rate</span>
          <input
            value={countryConfig.tax}
            className="input-class"
            name="tax"
            onChange={handleAddChange}
            id=""
          ></input>
        </div>
        <div>
          <span className="span-class">Currency</span>
          <input
            className="input-class"
            disabled
            name="currency"
            value={countryConfig?.currency}
          ></input>
        </div>
        <div>
          <span>Booking Amount Percent</span>
          <input
            onChange={handleAddChange}
            className="input-class"
            name="booking_amount_percent"
            value={countryConfig.booking_amount_percent}
            id=""
          ></input>
        </div>
        <button className="button-class-white" onClick={handleSubmit}>
          Submit
        </button>
      </div>
    </MainLayout>
  );
};

export default AddCountryConfig;
